import { FC } from 'react'
import styled from 'styled-components'

import { Info, TypeStyle } from '@syconium/little-miss-figgy'

import { useLocalization } from '../../../../../app/_providers/LocalizationProvider.client'
import { useTranslation } from '../../../../../app/_providers/TranslationProvider.client'
import { intlPrettyCurrency } from '../../../../../lib/utils'
import { StyledTooltip } from '../../shared-form-styles'
import { LogoFormContainer } from '../LogoFormContainer'

export const LogoColorDisplay: FC = () => {
  const { logoColorPrice } = LogoFormContainer.useContainer()
  const { region, locale } = useLocalization()
  const {
    embroidery: {
      modal: {
        forms: { dtcLogoEmbroideryForm: fixtures, logoOption },
      },
    },
  } = useTranslation()

  const price = intlPrettyCurrency({
    unit: 'cents',
    value: logoColorPrice,
    region: region,
    locale: locale,
    truncateTrailingZeros: true,
  })

  return (
    <Container>
      <Label>
        {logoOption.logoColorLabel}:
        <StyledTooltip content={<>{fixtures.logoColorPriceTooltip}</>} placement='bottom-start'>
          <button type='button' aria-label={fixtures.ariaLabelLogoColorTooltip}>
            <Info height='12px' width='12px' fill='#282828' />
          </button>
        </StyledTooltip>
        <PriceLabel>{price}</PriceLabel>
      </Label>
    </Container>
  )
}

const Container = styled.div`
  display: flex;
  justify-content: space-between;
`

const Label = styled.label`
  ${TypeStyle.css.headlineMicro}
  display: flex;
  align-items: center;
  gap: ${o => o.theme.spacing(2)};
  text-transform: uppercase;
  font-weight: ${o => o.theme.typography.font.weight[700]};
  letter-spacing: 2px;
  line-height: 18px;
`

const PriceLabel = styled(TypeStyle.BodySmall)`
  font-weight: ${o => o.theme.typography.font.weight[700]};
  line-height: 20px;
`
